/**
 * 
 * This files purpose is to warn and hopefully prevent users from closing the portal during Background Uploads for Face Incident Assets.
 *  
 */

class TabCloseWarningService {
  constructor() {
    this.installed = false;
    this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
  }

  install() {
    if (this.installed) return;

    window.addEventListener('beforeunload', this.handleBeforeUnload);
    this.installed = true;
    console.log('Tab close warning service installed');
  }

  uninstall() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    this.installed = false;
  }

  handleBeforeUnload(event) {
    if (sessionStorage.getItem("activeUploads") === "true") {
      const message = 'Upload in progress! If you leave now, your uploads will be canceled. Are you sure you want to leave?';
      event.preventDefault();
      event.returnValue = message;
      return message;
    }
  }
}

export default new TabCloseWarningService();